import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { Device } from '@iot-platform/models/i4b';
import { TranslatePipe } from '@ngx-translate/core';
import { DetailPopupCardsModule } from '../../detail-popup-cards/detail-popup-cards.module';
import { DetailPopupModule } from '../../detail-popup/detail-popup.module';

@Component({
  imports: [FlexLayoutModule, TranslatePipe, DetailPopupModule, DetailPopupCardsModule],
  selector: 'iot-platform-ui-device-details-connectors',
  templateUrl: './device-details-connectors.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./device-details-connectors.component.scss']
})
export class DeviceDetailsConnectorsComponent {
  device = input<Device | null>(null);
}
